export default __webpack_public_path__ + "456379a7e3a7c9d62854a4bb861a3ad7.png";